require('./angular-messages');
module.exports = 'ngMessages';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-messages/index.js
 ** module id = 147
 ** module chunks = 0
 **/